import $ from 'jquery';
import { getCSRFToken, getUserIdfromCookie } from '@shared/cookie';
import { T_ } from '@shared/translation';
import 'jquery-fileupload';

import 'jquery-fileupload-fp';
import 'jquery-fileupload-ui';

let initialDataFiles = [];

function init(initFiles, params) {
  const fileUrl = '/buyers/postproject-upload.php?fileset=';

  params = $.extend(
    {
      // default template names, to not break existing pages
      uploadTemplate: 'template-upload',
      downloadTemplate: 'template-download',
      domID: 'fileupload', // id of the fileupload element to use
      domEl: document, // container the fileupload element will be found in
    },
    params,
  );

  if (Object.prototype.toString.call(initFiles) === '[object Array]') {
    initialDataFiles = initFiles;
  }

  // falls back to document > #fileupload, as per default
  const domEl = $(params.domEl);
  const fileuploadDom = domEl.find(`#${params.domID}`);

  // Initialize the jQuery File Upload widget:
  fileuploadDom.fileupload({
    maxFileSize: 20000000, // 20 MB
    dataType: 'json',
    dropZone: fileuploadDom,
    url: fileUrl,
    singleFileUploads: false,
    autoUpload: true,
    paramName: 'upload[]',
    uploadTemplateId: params.uploadTemplate,
    downloadTemplateId: params.downloadTemplate,
    add(e, data) {
      let isUploaded = false;
      const uploadedFileNames = [];
      for (let i = 0; i < data.files.length; i++) {
        if (
          $(`#project_files [value='${data.files[i].name}']`).length > 0 ||
          (initialDataFiles.length > 0 &&
            initialFileExists(data.files[i].name) === true)
        ) {
          uploadedFileNames.push(data.files[i].name);
          isUploaded = true;
        }
      }
      if (isUploaded) {
        domEl
          .find('.fileUploadError')
          .text(
            T_("You've already uploaded <%= filenames %>", {
              filenames: uploadedFileNames.join(', '),
            }),
          )
          .fadeIn()
          .delay(2000)
          .fadeOut('slow');
        return false;
      }
      const that = $(this).data('fileupload');
      const options = that.options;
      const files = data.files;
      $(this)
        .fileupload('process', data)
        .done(() => {
          that._adjustMaxNumberOfFiles(-files.length);
          data.isAdjusted = true;
          data.isValidated = that._validate(files);
          data.files.valid = data.isValidated;
          data.context = that._renderUpload(files).data('data', data);
          options.filesContainer[options.prependFiles ? 'prepend' : 'append'](
            data.context,
          );
          that._renderPreviews(files, data.context);
          that._forceReflow(data.context);
          that._transition(data.context).done(() => {
            if (
              that._trigger('added', e, data) !== false &&
              (options.autoUpload || data.autoUpload) &&
              data.autoUpload !== false &&
              data.isValidated
            ) {
              data.submit();
            }
          });
        });
    },
    destroy(e, data) {
      let fileName = $(data.context.context)
        .closest('.delete')
        .siblings('.name')
        .find('p')
        .text()
        .trim();
      if (fileName == '') {
        fileName = $(data.context.context)
          .closest('.delete')
          .siblings('.name')
          .text()
          .trim();
      }
      const that = $(this).data('fileupload');
      if (data.url) {
        $.ajax(data);
        that._adjustMaxNumberOfFiles(1);
      }
      that._transition(data.context).done(function() {
        $(this).remove();
        that._trigger('destroyed', e, data);
      });

      domEl.find(`#project_files [value='${fileName}']`).remove();

      const driveFileElem = domEl.find(
        `[data-upload-field="drive_files"] [data-filename="${fileName}"]`,
      );

      const driveFileId = driveFileElem.data('file-id');

      driveFileElem.remove();
      if (driveFileId && getUserIdfromCookie()) {
        fetch(`/ajax/files/deleteFile.php?id=${driveFileId}`, {
          credentials: 'same-origin',
          headers: new Headers({
            'X-XSRF-TOKEN': getCSRFToken(),
          }),
          method: 'DELETE',
        });
      }
    },
  });

  // override to get DND to work for IE
  fileuploadDom.unbind('dragover').bind('dragover', e => {
    const that = fileuploadDom.data('fileupload');
    const dataTransfer = e.originalEvent.dataTransfer;
    e.dataTransfer = dataTransfer;
    if (that._trigger('dragover', e) === false) {
      return false;
    }
    if (dataTransfer) {
      try {
        // workaround for IE
        dataTransfer.effectAllowed = 'copy';
      } catch (_error) {
        // do nothing
      }
      dataTransfer.dropEffect = 'copy';
    }
    e.preventDefault();
  });

  fileuploadDom
    .bind('fileuploadadd', (e, data) => {
      data.url = fileUrl + domEl.find('#proj_upload_fileset').val();
    })
    .bind('fileuploaddone', (e, data) => {
      $.each(data.result, (index, file) => {
        domEl.find('#proj_upload_fileset').val(file.fileset);

        domEl.find('#project_files').append(
          $('<option/>', {
            value: file.name,
            text: file.name,
            selected: true,
          }),
        );

        if (file.isDriveFile) {
          domEl.find('[data-upload-field="drive_files"]').append(
            $('<option/>', {
              value: file.id,
              text: file.name,
              selected: true,
              'data-file-id': file.id,
              'data-filename': file.name,
            }),
          );
        }
      });
    });

  fileuploadDom.find('input').attr('title', T_('No files selected.'));
}

function initialFileExists(filename) {
  if (initialDataFiles.indexOf(filename) >= 0) {
    return true;
  }

  return false;
}

export default {
  init,
};
